import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
  OnInit,
} from '@angular/core';
import { Observable } from 'rxjs';
import { TaskWorkspaceStore } from '../../../../../../../core/h3ml/state/task-workspace-store';
import { FeedbackListService } from '../../../../../../../core/shared/feedback/feedback-list.service';
import { ShapeService } from '../../../../../../../core/shared/misc-services/shape.service';
import { assertDefined } from '../../../../../../../cross-team-shared/misc-utils/strict-record';

@Component({
  selector: 'h3-shape-feedback-indicator',
  templateUrl: './shape-feedback-indicator.component.html',
  styleUrl: './shape-feedback-indicator.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class ShapeFeedbackIndicatorComponent implements OnInit {
  @Input({ required: true }) shapeIndex!: number;
  hasFeedback$!: Observable<boolean>;

  private store = inject(TaskWorkspaceStore);
  private feedbackListService = inject(FeedbackListService);
  private shapeService = inject(ShapeService);

  ngOnInit() {
    this.hasFeedback$ = this.store.shapeHasFeedback$(this.shapeIndex);
  }

  openFeedbackList() {
    const shape = this.shapeService.getShapeStore(this.shapeIndex).state();
    assertDefined(shape.parentId);
    this.feedbackListService.openFeedbackListForObject(shape.parentId, 'shape');
  }
}
